import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-partner-modal _flexcol _gap-6"
}
const _hoisted_2 = { class: "gfu-partner-modal__header _flex _fd-c _fd-r--m _gap-5" }
const _hoisted_3 = { class: "gfu-partner-modal__logo _flex-none" }
const _hoisted_4 = { class: "_flexcol _gap-2" }
const _hoisted_5 = { class: "_flex _ai-c _flexwrap _gap-2" }
const _hoisted_6 = { class: "gfu-partner-modal__meta _flex _fd-c _fd-r--m _flexwrap" }
const _hoisted_7 = {
  key: 0,
  class: "gfu-partner-modal__category"
}
const _hoisted_8 = { class: "_flex _flexwrap _gap-2" }
const _hoisted_9 = { class: "gfu-partner-modal__metrics" }
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = {
  key: 1,
  class: "gfu-partner-modal__socials"
}
const _hoisted_12 = ["href", "data-qa"]
const _hoisted_13 = {
  key: 0,
  class: "_flexcol _gap-4"
}
const _hoisted_14 = { class: "_grid _grid-cols-1 _grid-cols-2--m _gap-4" }
const _hoisted_15 = ["data-qa"]
const _hoisted_16 = { class: "_flexcol _gap-1" }
const _hoisted_17 = {
  key: 1,
  class: "gfu-partner-modal__section"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 2,
  class: "gfu-partner-modal__section"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_partner_image = _resolveComponent("partner-image")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_tag = _resolveComponent("base-tag")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel_indicators = _resolveComponent("base-carousel-indicators")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $props.isVisible,
    width: $options.modalWidth,
    "has-backdrop": "",
    "show-action-close": "",
    onActionClose: $options.onClose,
    onPrev: _cache[0] || (_cache[0] = $event => (_ctx.$emit('prev'))),
    onNext: _cache[1] || (_cache[1] = $event => (_ctx.$emit('next'))),
    "data-qa": "partner-detail-modal"
  }, {
    default: _withCtx(() => [
      ($props.partner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_partner_image, {
                  src: $options.logoUrl,
                  alt: $props.partner.name,
                  class: "gfu-partner-modal__logo-image"
                }, null, 8 /* PROPS */, ["src", "alt"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_base_title, {
                    as: "h2",
                    "data-qa": "partner-detail:Name"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.partner.name), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", null, [
                    ($options.hasSpecialBadge)
                      ? (_openBlock(), _createBlock(_component_base_badge, {
                          key: 0,
                          theme: "primary",
                          class: "_ma-0",
                          "data-qa": "partner-detail:Badge"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.specialBadgeName), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                ($props.partner.description)
                  ? (_openBlock(), _createBlock(_component_base_text, {
                      key: 0,
                      as: "div",
                      level: "b1",
                      "data-qa": "partner-detail:Description"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($props.partner.description), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              ($options.categoryTags.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_base_text, {
                      as: "div",
                      level: "caption",
                      class: "_ttu _tc--light _mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.CategoryLabel), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categoryTags, (tag) => {
                        return (_openBlock(), _createBlock(_component_base_tag, {
                          key: tag.id,
                          theme: "accent",
                          class: "_mb-0",
                          "data-qa": `partner-detail-category:${tag.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-qa"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.keyMetrics, (metric, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: metric.key,
                    class: "_flexcol _whs-nw",
                    "data-qa": `partner-detail-metric:${index}`
                  }, [
                    _createVNode(_component_base_text, {
                      as: "span",
                      level: "caption",
                      class: "_ttu _tc--light _mb-2",
                      "data-qa": "name"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(metric.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_base_title, {
                      as: "span",
                      level: "h2",
                      class: "gfu-partner-modal__metric-value _flex _ai-c",
                      "data-qa": "value"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(metric.value), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ], 8 /* PROPS */, _hoisted_10))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              ($options.socialLinks.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.socialLinks, (link) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: link.key,
                        href: link.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "_tc--dark _flex _ai-c _jc-c",
                        "data-qa": `partner-detail-social:${link.key}`
                      }, [
                        _createVNode(_component_base_icon, {
                          name: link.icon,
                          "icon-namespace": link.namespace,
                          size: "lg",
                          "is-fixed-width": ""
                        }, null, 8 /* PROPS */, ["name", "icon-namespace"])
                      ], 8 /* PROPS */, _hoisted_12))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            ($options.services.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                  _createVNode(_component_base_title, {
                    as: "h3",
                    level: "h2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.ServicesHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.services, (service, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: service.key,
                        class: "_flex _gap-2",
                        "data-qa": `partner-detail-service:${index}`
                      }, [
                        _createVNode(_component_base_icon, {
                          name: "check",
                          class: "_tc--accent",
                          size: "lg"
                        }),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_base_text, {
                            as: "div",
                            class: "_fw-b",
                            level: "b1",
                            "data-qa": "name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(service.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          (service.value)
                            ? (_openBlock(), _createBlock(_component_base_text, {
                                key: 0,
                                as: "div",
                                "data-qa": "value"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(service.value), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 8 /* PROPS */, _hoisted_15))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($options.testimonials.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                  _createVNode(_component_base_title, {
                    as: "h3",
                    level: "h2",
                    class: "_mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.TestimonialsHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_base_carousel, {
                    items: $options.testimonials,
                    class: "gfu-partner-modal__carousel"
                  }, {
                    default: _withCtx(({ currentItem }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.testimonials, (testimonial, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(['gfu-partner-modal__testimonial', { 'is-active': currentItem === index }])
                        }, [
                          (testimonial.imageUrl)
                            ? (_openBlock(), _createBlock(_component_base_image, {
                                key: 0,
                                src: testimonial.imageUrl,
                                alt: "",
                                class: "gfu-partner-modal__testimonial-logo _flex-none"
                              }, null, 8 /* PROPS */, ["src"]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", {
                            class: "gfu-richtext gfu-bt gfu-bt--b1",
                            innerHTML: testimonial.quote
                          }, null, 8 /* PROPS */, _hoisted_18)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    nav: _withCtx(({ onNext, onPrev }) => [
                      _createVNode(_component_base_carousel_navigation, {
                        type: "prev",
                        icon: "angle-left",
                        onClick: onPrev
                      }, null, 8 /* PROPS */, ["onClick"]),
                      _createVNode(_component_base_carousel_navigation, {
                        type: "next",
                        icon: "angle-right",
                        onClick: onNext
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]),
                    indicators: _withCtx(({ currentItem, onSetCurrentIndex }) => [
                      _createVNode(_component_base_carousel_indicators, {
                        class: "gfu-partner-modal__indicators",
                        "current-item": currentItem,
                        "items-count": $options.testimonials.length,
                        onSelected: onSetCurrentIndex
                      }, null, 8 /* PROPS */, ["current-item", "items-count", "onSelected"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["items"])
                ]))
              : _createCommentVNode("v-if", true),
            ($options.galleryImageUrls.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                  _createVNode(_component_base_title, {
                    as: "h3",
                    level: "h2",
                    class: "_mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.GalleryHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_base_carousel, {
                    items: $options.galleryImageUrls,
                    class: "gfu-partner-modal__carousel"
                  }, {
                    default: _withCtx(({ currentItem }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.galleryImageUrls, (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(['gfu-partner-modal__slide', { 'is-active': currentItem === index }])
                        }, [
                          _createVNode(_component_base_image, {
                            src: image,
                            alt: $props.partner.name,
                            class: "gfu-partner-modal__gallery-image"
                          }, null, 8 /* PROPS */, ["src", "alt"])
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    nav: _withCtx(({ onNext, onPrev }) => [
                      _createVNode(_component_base_carousel_navigation, {
                        type: "prev",
                        icon: "angle-left",
                        onClick: onPrev
                      }, null, 8 /* PROPS */, ["onClick"]),
                      _createVNode(_component_base_carousel_navigation, {
                        type: "next",
                        icon: "angle-right",
                        onClick: onNext
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]),
                    indicators: _withCtx(({ currentItem, onSetCurrentIndex }) => [
                      _createVNode(_component_base_carousel_indicators, {
                        class: "gfu-partner-modal__indicators",
                        "current-item": currentItem,
                        "items-count": $options.galleryImageUrls.length,
                        onSelected: onSetCurrentIndex
                      }, null, 8 /* PROPS */, ["current-item", "items-count", "onSelected"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["items"])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "width", "onActionClose"]))
}